<template>
<div class="delete_file">
        <OtherHead :tipText="$t('暂无内容')"></OtherHead>
        <div class="empty_content">
            <img src="@/assets/img/other/delete_file.png" alt=""/>
            <div class="empty_text">{{$t("文件已删除，无法查看")}}</div>
        </div>
    </div>
</template>

<script lang="ts">
import OtherHead from './OtherHead.vue'
export default {
    name: 'delete_file',
    components: {
        OtherHead
    },
    data() {
        return {

        }
    },
    computed: {

    },
    methods: {

    },
}
</script>

<style lang="scss" scoped>
.delete_file {
    flex: 1;
    display: flex;
    flex-direction: column;

    .empty_content {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;

        img {
            width: 131px;
        }

        .empty_text {
            margin-top: 16px;
            height: 20px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 14px;
            color: #A2A4B0;
            text-align: center;
        }
    }
}
</style>
